import { Place } from "../types/place"

export const BusinessHourTypeCode = {
  holiday: 0,
  opening: 1,
  opened: 2,
  twentyfour: 3,
  closed: 4,
} as const

export interface BusinessHourType {
  code?: typeof BusinessHourTypeCode[keyof typeof BusinessHourTypeCode]
  text?: string
}

export class BusinessHourSummary {
  static detect(place: Place): BusinessHourType {
    const now = new Date()
    if (place.targetHoliday) {
      return { code: BusinessHourTypeCode.holiday }
    }
    if (place.targetBusinessHours && place.targetBusinessHours.length == 0) {
      return {}
    }
    if (!place.targetBusinessHours) {
      return {}
    }

    const sorted = place.targetBusinessHours.sort((a, b) =>
      a.openingTime < b.openingTime ? -1 : 1
    )
    const hour = now.getHours()
    const min = now.getMinutes()
    for (let i = 0; i < sorted.length; i++) {
      if (!sorted[i].openingTime) {
        return { code: BusinessHourTypeCode.twentyfour }
      }
      const [openingHour, openingMinute] = sorted[i].openingTime.split(":")
      if (
        hour < parseInt(openingHour) ||
        (hour == parseInt(openingHour) && min < parseInt(openingMinute))
      ) {
        return {
          code: BusinessHourTypeCode.opening,
          text: `${sorted[i].openingTime}から営業`,
        }
      }
      const closings = sorted[i].closingTime
        .split(":")
        .map((time) => parseInt(time))
      let closingHour = closings[0]
      const closingMinute = closings[1]

      if (closingHour <= 5) {
        closingHour += 24
      }
      if (hour < closingHour || (hour == closingHour && min < closingMinute)) {
        return {
          code: BusinessHourTypeCode.opened,
          text: `${sorted[i].closingTime}まで営業`,
        }
      }
    }
    return { code: BusinessHourTypeCode.closed }
  }
}
